var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Published',{attrs:{"item":_vm.workflow},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('WorkflowDisplay',{attrs:{"args":{ workflow_id: _vm.id },"workflow":_vm.workflow,"expanded":true}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }